import React from 'react';

export default props => {
  const { isFleek = false } = props;
  return (
    <div className="main-photo-grid">
      <div className={`heading-shimmer-photo-grid ${isFleek ? 'fleek-shimmer-photo-grid' : ''}`} />
      <div className="photos-grid-container">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(eachValue => {
          return (
            <div
              className={`shimmer_lines each-card-photo-grid ${
                isFleek ? 'fleek-shimmer-photo-grid' : ''
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};
